__turbopack_context__.v({
  "container": "hero-mobile-module-scss-module__PIdPpq__container",
  "content": "hero-mobile-module-scss-module__PIdPpq__content",
  "datePill": "hero-mobile-module-scss-module__PIdPpq__datePill",
  "gallery": "hero-mobile-module-scss-module__PIdPpq__gallery",
  "mlsSection": "hero-mobile-module-scss-module__PIdPpq__mlsSection",
  "priceRow": "hero-mobile-module-scss-module__PIdPpq__priceRow",
  "statusPill": "hero-mobile-module-scss-module__PIdPpq__statusPill",
});
